import React, { useState } from 'react';

export interface IUploadingButtonProps {
    className: string;
    disabled: boolean;
    label: string;
    uploadingLabel: string;
    uploading: boolean;
    onClick: () => void;
}

const UploadingButton = (props: IUploadingButtonProps) => {
    const { className, disabled, label, uploadingLabel, uploading, onClick } = props;

    const [dotCount, setDotCount] = useState(0);
    const [ts, setTS] = useState(Date.now());
    
    React.useEffect(() => {
        setDotCount(dotCount + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ts]);

    React.useEffect(() => {
        var tmr: NodeJS.Timer | null = null;
        if (uploading) {
            console.log('Timer started...');
            tmr = setInterval(() => {
                setTS(Date.now());
            }, 500);
        }

        return () => {
            if (tmr) {
                console.log('Timer stopped...');
                clearInterval(tmr);
            }
        };
    }, [uploading]);

    const buttonText = React.useMemo(() => {
        if (!uploading) {
            return label;
        }

        const DOTS = [
            '...',
            '.',
            '..',
        ];

        return `${uploadingLabel}${DOTS[dotCount % 3]}`
    }, [ label, uploadingLabel, uploading, dotCount ]);

    return (
        <button
            className={className}
            data-name="adminBannerBlock"
            disabled={disabled}
            onClick={onClick}
        >
            <div className="flex flex-col items-center justify-center overflow-clip rounded-[inherit] h-full w-full">
                <div className="box-border content-stretch flex flex-col gap-[5px] items-center justify-center p-[16px] relative h-full w-full">
                    <div className="content-stretch flex flex-col items-center justify-center relative shrink-0 w-full" data-name="Switch Field">
                        <div className="content-stretch flex gap-[12px] items-center relative shrink-0" data-name="Checkbox and Label">
                            <p className="font-['Inter:Semi_Bold',sans-serif] font-semibold leading-[normal] not-italic relative shrink-0 text-[24px] text-center text-nowrap text-white whitespace-pre">{buttonText}</p>
                        </div>
                    </div>
                </div>
            </div>
        </button>
    );
};

export default UploadingButton;